import React from "react"
import { useElapsedTime } from "src/shared/hooks/useElapsedTime"
import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import RoomCardBody from "../../shared/RoomCardBody/RoomCardBody"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import Wrapper from "../../shared/Wrapper/Wrapper"

import "./Unclean.css"
import { useDate } from "src/shared/hooks/useDate"
import { useTimePulse } from "src/shared/hooks/useTimePulse"
import { useMaxWidthContext } from "../../../hooks/useMaxWidth"

const Unclean = ({ roomNumber, roomTypeName, dateStatusChanged, uncleanTimeLimit, hasIncidences }: RoomStatusProps) => {
    const { UTCStringToLocalDate } = useDate()
    const [elapsedTime] = useElapsedTime(UTCStringToLocalDate(dateStatusChanged))
    const [now] = useTimePulse()
    const { maxWidth } = useMaxWidthContext()

    const itemHeight = "20cqh"

    return (
        <Wrapper
            hasIncidences={hasIncidences}
            bgColor="#FFE99C"
            alertBgColor1={now > (uncleanTimeLimit || now) ? "#fff4cf" : null}
            alertBgColor2={now > (uncleanTimeLimit || now) ? "#ffe99c" : null}
            // className={now > (uncleanTimeLimit || now) ? "room-card--unclean__animated" : ""}
        >
            <RoomCardHeader
                hasIncidences={hasIncidences}
                roomNumber={roomNumber}
                iconBgColor="var(--sucia)"
                iconName="trashFilled"
            />
            <RoomCardBody>
                <div style={{ maxWidth }} className="room-card--xs--unclean__description__wrapper">
                    <span className="room-card--xs--unclean__timer" style={{ fontSize: itemHeight }}>
                        {elapsedTime}
                    </span>
                    <span className="room-card--xs--unclean__description" style={{ fontSize: itemHeight }}>
                        {roomTypeName}
                    </span>
                </div>
            </RoomCardBody>
        </Wrapper>
    )
}

export default Unclean
